<template>
<div id="reports">

    <v-row>
        <v-col cols="auto" v-for="(r,index) in reports" :key="index">
            <v-card @click="changeRoute(r.route)" outlined :style="`border: 1px solid ${r.color};border-left: 6px solid ${r.color}`">
                <v-card-title :style="`color:${r.color}`"><b>{{r.title}}</b></v-card-title>
                <v-card-text><b v-if="r.subtitle">{{evalExpression(r.subtitle)}}</b><br>{{r.description}}</v-card-text>
            </v-card>
        </v-col>
    </v-row>

</div>
</template>

<script>
import  {SUBSCRIBE_ALL_PRODUCTS_COUNT} from "../../graphql/subscriptions/Products";
import {SUBSCRIBE_ALL_CUSTOMERS_COUNT} from "../../graphql/subscriptions/Customers";
import {SUBSCRIBE_SALES_EXECUTIVE_COUNT} from "../../graphql/subscriptions/Users";

export default {
    name: "Reports",
    apollo: {
        $subscribe: {
            allProductsCount:{
                query: SUBSCRIBE_ALL_PRODUCTS_COUNT,
                result ({ data }) { this.allProductsCount = data.allProductsCount.aggregate.count }
            },
            allCustomersCount:{
                query: SUBSCRIBE_ALL_CUSTOMERS_COUNT,
                result ({ data }) { this.allCustomersCount = data.allCustomersCount.aggregate.count }
            },
            allSalesExecutiveCount:{
                query: SUBSCRIBE_SALES_EXECUTIVE_COUNT,
                result ({ data }) { this.allSalesExecutiveCount = data.allSalesExecutiveCount.aggregate.count }
            },
        }
    },
    data(){
        return {
            reports: [
                     /* {title: 'STOCK AMOUNT REPORT', route: '/stockAmountReport', color:'teal',
                       subtitle:`this.allProductsCount + ' Products'`, description:'See Product Stock with Total Amount'}, */
                      {title: 'SALES BY CUSTOMER/PRODUCT', route: '/productCustomerSalesReport', color:'#cc5500',
                       subtitle:`this.allProductsCount + ' Products, ' + this.allCustomersCount + ' Customers'`,
                       description:'See Sales Report By Product or Customer'},
                      {title: 'SALES EXECUTIVE REPORT', route: '/salesExecutiveReport', color:'orange',
                       subtitle:`this.allSalesExecutiveCount + ' Sales Executive'`, description:'See Sales Report By Sales Executive'},
                      {title: 'NO SOLD PRODUCT REPORT', route: '/noSoldProductReport', color:'#ed2938',
                       subtitle:`this.allProductsCount + ' Products'`, description:'See Products Which Are Not Sold'},
                     /* {title: 'CASH/CREDIT REPORT', route: '/paymentModeReport', color:'#7e7d9c',
                       description:'See Sales Report By Payment Mode'}, */
                      /*{title: 'PROFIT/LOSS REPORT', route: '/profitLossReport', color:'#ec407a',
                       description:'See Profit/Loss Report of Products'}*/ ],
            allProductsCount: 0,
            allCustomersCount: 0,
            allSalesExecutiveCount: 0
        }
    },
    methods:{
        changeRoute(route) {
            this.$router.push(route)
        },
        evalExpression(val){
           return eval(val)
        }
    }
}
</script>

<style scoped>
#reports{
    padding: 10px 30px;
}
</style>